module.exports = __webpack_public_path__ + "media/toolkits/checkmark-bullets-64d7333a.svg";